<template>
  <v-layout>
    <v-flex xs12 md6 offset-md3>
      <h2>This app is no longer in use, please contact fleetsupport@motia.com for details of how to access the new Nexus app.</h2>
    </v-flex>
  </v-layout>
</template>

<script>
import dbPromise from '../dbPromise'
import { firedb } from '../firebase'
import StatusOverview from './Shared/StatusOverview.vue'

export default {
  components: {
    StatusOverview
  },
  data () {
    return {
      snackbar: false,
      snackbarText: '',
      currentJob: false,
      snackbarTimeout: 1000
    }
  },
  firebase: {
    connected: firedb.ref('.info')
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  mounted () {
    this.checkCurrentJob()
  },
  methods: {
    checkCurrentJob () {
      dbPromise().then((db) => {
        let tx = db.transaction('currentJob')
        let currentStore = tx.objectStore('currentJob')
        return (currentStore.getAll())
      }).then((val) => {
        if (val.length > 0) {
          this.currentJob = false
        } else {
          this.currentJob = true
        }
      })
    },
    refreshApp () {
      window.location.reload(true)
    }
  }
}

</script>



// WEBPACK FOOTER //
// Hello.vue?a1b10eaa